import { connect } from 'react-redux';
import View from './ChildrenAddEditView';
import { currentClientId } from '../../AdvWorkflow/AdvWorkflowSelector';
import childrenSelector, {
  indexSelector,
  childSelector,
  isEditSelector,
} from './ChildrenAddEditSelector';
import {
  updateData,
  updateSupportData,
  save,
  updateValidation,
  fetchData,
} from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY, CHILDREN_CRUD_OVERVIEW } from '../PersonalInfoWorkflowConstants';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';
import { validateChild } from '../PersonalInfoWorkflowValidator';
import { onCancel } from './ChildrenAddEditActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  children: childrenSelector(state, ownProps),
  child: childSelector(state, ownProps),
  index: indexSelector(state, ownProps),
  isEdit: isEditSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onSave: (children, workflowId, { name, age }, index, clientId) => () => {
    const errorList = validateChild(name, age);
    if (errorList.length > 0) {
      return dispatch(
        updateValidation(
          buildMutation(`${BACKEND_KEY}.ChildrenAddEdit`, errorList),
          workflowId,
          clientId,
        ),
      );
    }

    const childrenUpdated = children.map(({ Dob, ...child }, iterator) => {
      if (iterator === index) {
        return {
          ...child,
          Age: age,
          FirstName: name,
        };
      }
      return child;
    });

    dispatch(
      updateData(
        {
          [BACKEND_KEY]: {
            Dependents: childrenUpdated,
          },
        },
        workflowId,
        clientId,
      ),
    );

    dispatch(
      updateValidation(buildMutation(`${BACKEND_KEY}.ChildrenAddEdit`, []), workflowId, clientId),
    );
    return dispatch(
      save(
        BACKEND_KEY,
        () => {
          dispatch(
            updateSupportData(
              {
                [BACKEND_KEY]: {
                  ChildrenStepViewID: CHILDREN_CRUD_OVERVIEW,
                  SelectedChildFirstName:
                    childrenUpdated.length > 0
                      ? childrenUpdated[childrenUpdated.length - 1].FirstName
                      : '',
                },
              },
              workflowId,
              clientId,
            ),
          );

          dispatch(fetchData(workflowId, clientId, ['PersonalInfo'], true));
        },
        errors => {
          dispatch(
            updateValidation(
              buildMutation(`${BACKEND_KEY}.ChildrenAddEdit`, errors),
              workflowId,
              clientId,
            ),
          );
        },
        workflowId,
        clientId,
        false,
        d => d,
        () => {},
      ),
    );
  },
  onCancel: (workflowId, clientId, isEdit, children) => event => {
    event.preventDefault();
    event.stopPropagation();

    dispatch(onCancel(workflowId, clientId, isEdit, children));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
